
import InstanceBox from './index.vue';
import { dialog } from '@/plugins/dialog/index'

export default function (options?) {
  options = Object.assign({
    multiple: true
  }, options)
  return dialog({
    title: '商品分组',
    content() {
      return <InstanceBox options={options}></InstanceBox>
    }
  })
}